var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderTableColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1367 9H2.13672V11H13.1367V9ZM13.1367 5H2.13672V7H13.1367V5ZM17.1367 13V9H15.1367V13H11.1367V15H15.1367V19H17.1367V15H21.1367V13H17.1367ZM2.13672 15H9.13672V13H2.13672V15Z",
    fill: "#89A6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderTableColumn);
export default __webpack_public_path__ + "static/media/order-table-column.25003568a4b988a753ed5a828ea6b224.svg";
export { ForwardRef as ReactComponent };